<template>
  <div class="isHasOtherStore">
    <rich-radio-group >
      <div v-for="(item, index) in options" :key="index">
        <rich-radio :option="item"  v-model="data" @input="dataChange"/>
        <rich-checkbox-group ref="checkbox" v-if="item.options && data === item.value" v-model="remark[item.value]" @input="remarkChange">
          <div v-for="(it, idx) in item.options" :key="idx"  class="indent">
            <rich-checkbox :option="{label: it.label, value: it.value}"/>
            <rich-radio-group :ref="it.value" v-if="it.options && isChecked(it.value)" :options="it.options" v-model="option[it.value]" @input="optionChange"/>
            <span class="check-required" v-if="!it.options && isChecked(it.value)">*</span>
            <rich-input type="text" :ref="it.value" v-if="!it.options && isChecked(it.value)" v-model="option[it.value]" :placeholder="$t('Gattaran_0__XIOS' /**请输店铺数量 */)" @blur="optionChange(it, idx)"/>
            <div
              class="error-msg"
              v-if="showErrs[it.value] && !it.options && isChecked(it.value)"
              v-text="errmsg"
            ></div>
          </div>
          <div
            class="error-msg"
            v-if="showErr"
            v-text="errmsg"
          ></div>
        </rich-checkbox-group>
      </div>
    </rich-radio-group>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash-es'
  export default {
    data () {
      const options = this.options || []
      const remark = {}
      console.log('options =>', this.options)
      options.forEach(item => {
        remark[item.value] = []
      })
      return {
        data: '',
        remark,
        option: {
          storeNum: '',
          cooperateNum: ''
        },
        showValue: {},
        showErr: false,
        errmsg: this.gettext('选项和输入框不能为空'),
        showErrs: {}
      }
    },
    props: {
      options: {},
      value: {
        required: false,
        type: [String, Array, Object]
      }
    },
    watch: {
      value (nVal) {
        this.initValue(nVal)
      }
    },
    created () {
      this.initValue(this.value)
    },
    methods: {
      dataChange () {
        this.change()
      },

      remarkChange () {
        this.change()
      },

      optionChange (item, key) {
        let checked = {}
        let testNum = ''
        if (key === 0) {
          checked['storeNum'] = ''
          testNum = /[^\d.]/g.test(this.option['storeNum'])
        }
        if (key === 1) {
          checked['cooperateNum'] = ''
          testNum = /[^\d.]/g.test(this.option['cooperateNum'])
        }
        if (testNum) {
          this.option = cloneDeep(Object.assign({}, this.option, checked))
        }
        this.change()
      },

      initValue (val = {}) {
        for (let key in val) {
          this.data = key
          const remarkData = val[key] || []
          const remark = []
          remarkData.forEach(item => {
            for (let key2 in item) {
              remark.push(key2)
              this.option[key2] = item[key2]
            }
          })
          this.remark[key] = remark
        }
      },
      getValue () {
        const data = {}
        if (this.data) {
          data[this.data] = []
        }
        const currentRemark = this.remark[this.data] || []
        currentRemark.forEach(item => {
          data[this.data].push({
            [item]: this.option[item] || ''
          })
        })
        return data
      },
      change () {
        let value = this.getValue()
        this.showValue = value
        this.$emit('input', value)
      },
      isChecked (value) {
        const data = this.remark[this.data]
        return data.includes(value)
      },
      validate (cb) {
        let value = this.getValue()
        let pass = true
        this.showErrs = {}
        if (!this.data) pass = false
        else {
          const checkValue = value[this.data] || []
          if (this.$refs && this.$refs.checkbox && this.$refs.checkbox[0] && checkValue.length === 0) {
            pass = false
          } else {
            for (let i = 0; i < checkValue.length; i++) {
              const item = checkValue[i]
              for (let key in item) {
                if (this.$refs && this.$refs[key] && this.$refs[key][0] && !item[key]) {
                  this.showErrs = Object.assign({}, this.showErrs, {
                    [key]: true
                  })
                }
                this.showErrs[key] && (pass = false)
              }
            }
          }
        }
        const innerErrs = Object.values(this.showErrs).filter(item => item)
        const hasInnerErr = innerErrs.length
        this.showErr = !hasInnerErr && !pass
        if (!this.$refs.checkbox) {
          this.showErr = false
        }
        cb && pass && cb(pass)
        return pass
      }
    }
  }
</script>

<style lang="scss" scoped>
.isHasOtherStore {
  .indent {
    padding-left: 45px;
  }
}

.error-msg {
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}

.check-required {
  color: #e64340;
  position: relative;
  top: 54Px;
  z-index: 1;
}
</style>
